import './utils/rem'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import Components from '@/components'
import Directive from '@/directive'
import './assets/styles/main.scss'
import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import router from './router'
import { initDynamicCSP } from './plugins/csp'

// async function loadDev() {
//   console.log(import.meta.env.MODE)
//   if (import.meta.env.MODE !== 'production') {
//     const { default: eruda } = await import('eruda')
//     console.log(eruda)
//     eruda.init()
//   }
// }
//loadDev()

// 初始化Vuetify（基础配置）
const vuetify = createVuetify({
  theme: false,
  defaults: {
    global: {
      ripple: false, // 禁用会产生内联样式的功能
      elevation: false,
      transitions: false
    }
  },
  // 全局配置...
  icons: {
      defaultSet: 'mdi',
      aliases,
      sets: { mdi },
    }
})
const app = createApp(App)

// 初始化路由感知的 CSP
const routeCSP = {
  '/': "img-src 'self' data:;",
  '/login': "img-src 'self' data:;",
  '/chat': "img-src 'self' data:;",
  '/nocsp': "img-src 'self' data:;",
};
initDynamicCSP(routeCSP);
app.use(vuetify)
app.use(createPinia()).use(router).use(Components).use(Directive)

app.mount('#app')
